import styled from 'styled-components';
// import { Link } from 'react-router-dom';
import { Button } from '@finect/tabular-core/Button';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { getFont } from '@finect/tabular-utils/getFont';

export const AskQuestion = styled(Button)`
  width: auto;
  border: 1px solid ${({ theme }) => theme.borderColor};
  background-color: transparent;
  ${getFont(-1)};
  font-weight: 600;
  line-height: 1.2em;
  color: ${({ theme }) => theme.secondaryColor};

  &:not([disabled]):hover {
    background-color: ${({ theme }) => theme.secondaryColor};
    color: #fff;
  }

  ${maxMediaQueries.phablet`
    text-transform: capitalize;

    span {
      display: none;
    }
  `};
`;
